import { WorkItem } from '../api/workItems';
import { ViewKey } from '../components/WorkItemsView.constants';

/**
 * Logic to determine if a work item should be visible in the current view/filter context.
 * Useful for optimistic UI updates (e.g., should we show a newly created/imported item?).
 */
export const shouldInsertNewItem = (
    item: WorkItem,
    context: {
        currentView: ViewKey;
        areaFilter: string | null;
        stateFilter: string;
        needsActionOnly: boolean;
    }
): boolean => {
    const { currentView, areaFilter, stateFilter, needsActionOnly } = context;

    const type = String(item.type || '').toUpperCase();
    const state = String(item.state || '').toUpperCase();
    const domain = String(item.domain || '').toLowerCase();

    // 1. View Type Matching
    if (currentView === 'applications' && type !== 'APPLICATION') return false;
    if (currentView === 'tasks' && type !== 'TASK') return false;
    if (currentView === 'inbox' && type !== 'INBOX') return false;

    // 2. Area (Domain) Matching
    if (areaFilter != null && areaFilter !== 'all' && domain && domain !== areaFilter) return false;

    // 3. State Matching (comma-separated list or 'ALL')
    if (stateFilter !== 'ALL') {
        const allowed = stateFilter
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean);
        if (state && allowed.length > 0 && !allowed.includes(state)) return false;
    }

    // 4. Action Required Matching
    if (needsActionOnly && !item.needs_action) return false;

    return true;
};
